import { render, staticRenderFns } from "./InvoiceTour.vue?vue&type=template&id=3f796b18"
import script from "./InvoiceTour.vue?vue&type=script&lang=js"
export * from "./InvoiceTour.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTour.vue?vue&type=style&index=0&id=3f796b18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports